import { computed } from 'vue';
import { useStore } from 'vuex';

/**
 * Composable for state
 * Usage in Composition API:
 * 
 * import { useState } from '@/composables/state';
 * 
 * export default {
 *   setup() {
 *     const { activeTab, breadcrumbDetails, canUpdateBreadcrumb, cart, cartMeta, colorBubbles, deletePPModal, deleteProdModal, dynamicBreadcrumb, isLoggingOut, loggedinUser, quote, shopMegaMenu, wl, wishList, wishListItems } = useState();
 *     return { activeTab, breadcrumbDetails, canUpdateBreadcrumb, cart, cartMeta, colorBubbles, deletePPModal, deleteProdModal, dynamicBreadcrumb, isLoggingOut, loggedinUser, quote, shopMegaMenu, wl, wishList, wishListItems };
 *   }
 * }
 */
export function useState() {
    const store = useStore();

    const activeTab = computed(() => store.state.activeTab);
    const breadcrumbDetails = computed(() => store.state.breadcrumbDetails);
    const canUpdateBreadcrumb = computed(() => store.state.canUpdateBreadcrumb);
    const cart = computed(() => store.state.cart);
    const cartMeta = computed(() => store.state.cartMeta);
    const colorBubbles = computed(() => store.state.colorBubbles);
    const deletePPModal = computed(() => store.state.deletePPModal);
    const deleteProdModal = computed(() => store.state.deleteProdModal);
    const dynamicBreadcrumb = computed(() => store.state.dynamicBreadcrumb);
    const isLoggingOut = computed(() => store.state.isLoggingOut);
    const loggedinUser = computed(() => store.state.loggedinUser);
    const quote = computed(() => store.state.quote);
    const shopMegaMenu = computed(() => store.state.shopMegaMenu);
    const wl = computed(() => store.state.wl);
    const wishList = computed(() => store.state.wishList);
    const wishListItems = computed(() => store.state.wishListItems);

    return {
        activeTab,
        breadcrumbDetails,
        canUpdateBreadcrumb,
        cart,
        cartMeta,
        colorBubbles,
        deletePPModal,
        deleteProdModal,
        dynamicBreadcrumb,
        isLoggingOut,
        loggedinUser,
        quote,
        shopMegaMenu,
        wl,
        wishList,
        wishListItems,
    };
}